// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"style_dropdown__1PdDF","icon":"style_icon__38TQG"};